export default __webpack_public_path__ + "static/media/teacher_report.16fe6590.svg";